import { Base } from "../../framework/base";
import { IdTitle, IIdTitle } from "./idTitle";

export interface IIdColorTitle extends IIdTitle {
    color: string;

    getHash(): string;
}

export class IdColorTitle extends IdTitle implements IIdColorTitle {
    color: string;

    constructor();
    constructor(obj: IIdTitle);
    constructor(obj?: any) {
        super(obj);
        this.color = obj && obj.color || "";
    }

    static createIdColorTitle(id: string, color: string, title: string): IIdColorTitle {
        const result = new IdColorTitle();
        result.id = id;
        result.color = color;
        result.title = title;
        return result;
    }

    getHash(): string {
        return this.id + "#" + this.title + "#" + this.color;
    }

    static getHash(items: IIdColorTitle[]): string {
        if (!items || items.length < 1) return "";
        return Base.joinSuffix(items.map(i => i.getHash()), "$");
    }
            
    static sortIdTitles(items: IIdColorTitle[], asc: boolean): IIdColorTitle[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: IIdColorTitle, b: IIdColorTitle) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.getTitle(), b.getTitle())); });
    }
}